import { RiToolsLine } from '@remixicon/react';

import { ToolGroupEntry } from '../../extensions/tool-extension';

export const DEFAULT_TOOL_ICON = RiToolsLine;

export const formatDefaultToolLabel = (
  entry: ToolGroupEntry,
): { text: string; detail?: string } => {
  return { text: entry.displayName ?? entry.tool.replace(/_/g, ' ') };
};
